<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/ccdsinfotop.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议时间</div>
                </div>
            </div>
            <div class="neirong ziti">2025年9月12-14日</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议地点</div>
                </div>
            </div>
            <div class="neirong ziti">上海虹桥宾馆（上海市长宁区延安西路 2000 号）</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">参会对象</div>
                </div>
            </div>
            <div class="neirong ziti">国内知名皮肤外科专家、皮肤外科临床医师、各大院校在校学生</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主办单位</div>
                </div>
            </div>
            <div class="neirong ziti">中国医药教育协会</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/joinicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">承办单位</div>
                </div>
            </div>
            <div class="neirong ziti">中国医药教育协会皮肤与健康教育专业委员会</div>
            <div class="neirong ziti">复旦大学附属华山医院</div>
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'ccdsinfo',
    data() {
        return {
            map: null,
            zoom: 17,
            position: [121.4263217, 31.167118],
            events: {},
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initccdsShare();
        document.title = "CCDS第四届中国皮肤外科大会";
    },
    methods: {
        handleMapInit(map) {
            this.map = map;
            // 添加标点
            this.addMarker();
        },
        addMarker() {
            const position = [121.4263217, 31.167118]; // 经纬度
            // this.marker = new AMap.Marker({
            //     position: position,
            //     map: this.map,
            // });
        },
        goapp(lat, lng, name) {
            window.location.href = "https://uri.amap.com/marker?position=121.4263217,31.167118"
            // let isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            // let scheme = isIOS ? 'iosamap://' : 'androidamap://';
            // let url = `${scheme}navi?sourceApplication=web&poiname=${encodeURIComponent(name)}&lat=${lat}&lon=${lng}&dev=0`;

            // window.location.href = url;
            // setTimeout(() => {
            //     if (!document.hidden) {
            //         window.location.href = 'https://www.amap.com/download';
            //     }
            // }, 2000);
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
    margin-bottom: 0.2rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitle1 {
    background: rgb(0, 53, 133);
    width: 45%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.08rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    // padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin: auto;
    margin-top: 0.3rem;
    width: 95%;
}

.neirong1 {
    margin: auto;
    margin-top: 0.3rem;
    width: 88%;
    list-style: decimal;
}

.ziti {
    font-size: .37rem;
    width: 95%;
    margin: auto;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
    margin: 0.08rem 0;
}

.name2 {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
    margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.darkperplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.mapview {
    width: 90%;
    margin: auto;
    height: 5.5rem;
    margin-top: 0.5rem;
}

.lasttext {
    width: 100%;
    text-align: center;
    margin-top: .5rem;
    padding-bottom: 1rem
}

.nameflex {
    display: flex;
    flex-direction: row;
}
</style>